
import { Button } from "@/components/ui/button";
import { Plus, ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@/lib/theme/ThemeContext";

interface ChildrenHeaderProps {
  onAddChild: () => void;
}

export function ChildrenHeader({ onAddChild }: ChildrenHeaderProps) {
  const navigate = useNavigate();
  const isLightTheme = false;

  return (
    <div className="flex justify-between items-center mb-6">
      <div className="flex items-center gap-2">
        <Button
          variant="ghost"
          size="sm"
          className={`${isLightTheme ? "text-blue-600 hover:text-blue-700 hover:bg-blue-50" : "text-slate-400 hover:text-white"}`}
          onClick={() => navigate("/dashboard")}
        >
          <ChevronLeft className="h-4 w-4 mr-1" />
          Back to Dashboard
        </Button>
        <h1 className="text-2xl font-bold">Your Children</h1>
      </div>
      <Button
        onClick={onAddChild}
        size="sm"
        className={isLightTheme ? "bg-blue-primary hover:bg-blue-600" : ""}
      >
        <Plus className="h-4 w-4 mr-1" /> Add Child
      </Button>
    </div>
  );
}
